import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  deliveryMethods: {
    marginBottom: '20px',
    '& .MuiListItem-root:first-of-type': {
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
    },
    '& .MuiListItem-root:last-of-type': {
      borderBottomLeftRadius: '4px',
      borderBottomRightRadius: '4px',
    },
  },
  holdUntilMondayCheckbox: {
    alignItems: 'flex-start',
    color: '#696969',
    marginBottom: '20px',
    // Make sure the top of the checkbox is aligned with the top of the text on small
    // layouts when the text wraps, but is centered vertically with the text when the
    // text does not wrap:
    '& .MuiButtonBase-root': {
      paddingBottom: 0,
      paddingTop: 0,
    },
    '& strong': {
      color: theme.palette.primary.main,
    },
  },
}))
